import React from 'react';
import styles from './WidgetBox.module.css';
import WidgetTitle, { WidgetTitleProps } from './WidgetTitle';

type WidgetBoxProps = WidgetTitleProps & {
    children: JSX.Element;
};

function WidgetBox({ children, title, leftElement, rightElement }: WidgetBoxProps): JSX.Element {
    return (
        <div className={styles.wrapper}>
            {title && <WidgetTitle title={title} leftElement={leftElement} rightElement={rightElement} />}
            <div className={styles.content}>{children}</div>
        </div>
    );
}

export default WidgetBox;
